import { render, staticRenderFns } from "./personalInformationSetting.vue?vue&type=template&id=13992608&scoped=true"
import script from "./personalInformationSetting.vue?vue&type=script&lang=js"
export * from "./personalInformationSetting.vue?vue&type=script&lang=js"
import style0 from "./personalInformationSetting.vue?vue&type=style&index=0&id=13992608&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13992608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13992608')) {
      api.createRecord('13992608', component.options)
    } else {
      api.reload('13992608', component.options)
    }
    module.hot.accept("./personalInformationSetting.vue?vue&type=template&id=13992608&scoped=true", function () {
      api.rerender('13992608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myBoardChild/personalInformationSetting.vue"
export default component.exports